
<template>
  <b-modal
    v-if="workspace"
    ref="modal"
    id="agWsModal"
    class="agModal"
    :class="{'agModal-loading':isLoading}"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @keyup.enter.native="saveButton_click">
    <template slot="modal-header">
      <h4 v-if="isReadonly" class="agModal-title">View Workspace</h4>
      <h4 v-else-if="isEditing" class="agModal-title">Edit Workspace</h4>
      <h4 v-else class="agModal-title">New Workspace</h4>
    </template>
    <b-input-group size="md" prepend="Name">
      <b-input
        type="text"
        v-model="workspace.name"
        :disabled="isReadonly || isEditing"
        :state="hasError('name')"
      ></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="Description">
      <b-input
        type="text"
        v-model="workspace.description"
        :disabled="isReadonly"
        :state="hasError('description')"
      ></b-input>
    </b-input-group>
    <hr />
    <div class="agInputGroup">
      <label>Owner:</label>
      <b-form-select v-model="tempOwner" :options="ownerOptions" :disabled="isReadonly"></b-form-select>
    </div>
    <div class="agInputGroup">
      <label>Groups:</label>
      <b-table id="agWsModal-groupsTable" :items="groupItems" borderless outlined small>
        <template #head(enabled)>
          <input
            type="checkbox"
            v-model="groupsEnableAll"
            :disabled="isReadonly"
            @click="groupsEnableAll_click"
          />
        </template>
        <template #cell(enabled)="data">
          <input type="checkbox" v-model="data.item.enabled" :disabled="isReadonly" />
        </template>
      </b-table>
    </div>
    <div class="agInputGroup">
      <label>Users:</label>
      <b-table id="agWsModal-usersTable" :items="userItems" borderless outlined small>
        <template #head(enabled)>
          <input
            type="checkbox"
            v-model="usersEnableAll"
            :disabled="isReadonly"
            @click="usersEnableAll_click"
          />
        </template>
        <template #cell(enabled)="data">
          <input
            type="checkbox"
            v-model="data.item.enabled"
            :disabled="isReadonly || data.item.username == tempOwner.username"
          />
        </template>
      </b-table>
    </div>
    <div v-if="modalMessage">
      <hr />
      <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
    </div>
    <template slot="modal-footer" slot-scope="{cancel}">
      <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
      <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
      <b-button
        class="agModal-buttonRight"
        variant="primary"
        :disabled="isReadonly || isLoading"
        @click="saveButton_click"
      >Save</b-button>
    </template>
  </b-modal>
</template>






<script>
// components

// modules
import Util from "src/util/util";

export default {
  name: "ag-workspace-modal",
  components: {},
  props: {
    workspace: Object
  },
  data() {
    return {
      isLoading: false,
      modalMessage: "",
      modalMessageClass: "",
      errorField: "",
      tempOwner: "",
      groupsEnableAll: false,
      usersEnableAll: false,
      groupItems: [],
      userItems: []
    };
  },
  computed: {
    isReadonly() {
      if (
        this.user.role != "admin" &&
        (this.user.role == "readonly" ||
          (this.tempOwner && this.tempOwner._id != this.user._id))
      )
        return true;
      return false;
    },

    isEditing() {
      if (this.workspace._id) return true;
      return false;
    },

    user() {
      return this.$store.state.userStore.user;
    },

    groups() {
      return this.$store.state.userStore.groups;
    },

    users() {
      return this.$store.state.userStore.users;
    },

    ownerOptions() {
      var options = [];
      for (var i = 0; i < this.users.length; i++) {
        var user = this.users[i];
        options.push({ value: user, text: user.username });

        if (this.tempOwner && user._id == this.tempOwner._id) {
          this.tempOwner = user;
        }
      }

      return options;
    }
  },
  watch: {
    tempOwner: function() {
      var hasUser = this.workspace.users.find(a => a._id == this.tempOwner._id);
      if (!hasUser) this.workspace.users.push(this.tempOwner);
      this.setUserItems();
    }
  },

  created() {},

  mounted() {},

  methods: {
    // UI Events

    async saveButton_click() {
      if (!this.validate()) {
        return false;
      }

      this.workspace.owner = this.tempOwner;

      // add owner to users if not already there
      var hasUser = this.workspace.users.find(
        a => a._id == this.workspace.owner._id
      );
      if (!hasUser) this.workspace.users.push(this.workspace.owner);

      // build groups array
      this.workspace.groups = [];
      for (var i = 0; i < this.groupItems.length; i++) {
        var groupItem = this.groupItems[i];
        if (groupItem.enabled) {
          var group = this.groups.find(a => a.name == groupItem.name);
          if (group) this.workspace.groups.push(group);
        }
      }

      // build users array
      this.workspace.users = [];
      for (var i = 0; i < this.userItems.length; i++) {
        var userItem = this.userItems[i];
        if (userItem.enabled) {
          var user = this.users.find(a => a.username == userItem.username);
          if (user) this.workspace.users.push(user);
        }
      }

      if (this.isEditing) var func = "updateWorkspace";
      else var func = "insertWorkspace";

      this.isLoading = true;
      var result = await this.$store.dispatch("wsStore/" + func, {
        workspace: this.workspace
      });
      this.isLoading = false;
      if (result.data.success) {
        this.hide();
        this.$emit("reloadWorkspaces");
      } else {
        if (result.data.error.indexOf("duplicate key") > -1)
          this.modalMessage =
            'A workspace named "' + this.workspace.name + '" already exists';
        else this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    groupsEnableAll_click(e) {
      var enabled = e.currentTarget.checked;
      for (var i = 0; i < this.groupItems.length; i++) {
        var group = this.groupItems[i];
        group.enabled = enabled;
      }
    },

    usersEnableAll_click(e) {
      var enabled = e.currentTarget.checked;
      for (var i = 0; i < this.userItems.length; i++) {
        var user = this.userItems[i];
        if (user.username == this.tempOwner.username) user.enabled = true;
        else user.enabled = enabled;
      }
    },

    // emitted Events

    // other

    show() {
      setTimeout(() => {
        this.reset();
        this.$refs.modal.show();
      }, 250);
    },

    hide() {
      this.$refs.modal.hide();
    },

    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";
      this.tempOwner = this.workspace.owner;
      this.setGroupItems();
      this.setUserItems();
    },

    hasError(field) {
      if (field == this.errorField) {
        return false; // false = error
      }
      return null;
    },

    validate() {
      if (this.workspace.name.length == 0) {
        this.errorField = "name";
        this.modalMessage = "Name is required";
        this.modalMessageClass = "agModal-errorMessage";
        return false;
      }
      return true;
    },

    setGroupItems() {
      this.groupItems = [];
      for (var i = 0; i < this.groups.length; i++) {
        var group = this.groups[i];
        var inWorkspace = this.workspace.groups.find(a => a.name == group.name);
        if (inWorkspace)
          this.groupItems.push({ enabled: true, name: group.name });
        else this.groupItems.push({ enabled: false, name: group.name });
      }
    },

    setUserItems() {
      this.userItems = [];
      for (var i = 0; i < this.users.length; i++) {
        var user = this.users[i];
        var inWorkspace = this.workspace.users.find(
          a => a.username == user.username
        );
        if (inWorkspace || (this.tempOwner && user._id == this.tempOwner._id))
          this.userItems.push({
            enabled: true,
            username: user.username,
            name: user.name
          });
        else
          this.userItems.push({
            enabled: false,
            username: user.username,
            name: user.name
          });
      }
    }
  }
};
</script>






<style scoped lang="css">
#agWsModal-groupsTable,
#agWsModal-usersTable {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 155px);
  height: 175px;
  overflow: auto;
  border-collapse: collapse;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/WorkspaceModal.vue